<div class="modal-header">
  <h4 class="modal-title h1 pull-left">Add purchase</h4>
  <btn-close class="pull-right" (click)="modalRef.hide()"></btn-close>
</div>
<div class="modal-body">
  <div class="mb-3">
    <p>
      <span class="font-weight-medium">ID: {{ user }}</span>

      <ng-container *ngIf="item.account">
        <br>
        <span class="text-muted">{{ item.account.email }}</span>
      </ng-container>
    </p>
  </div>
  <form [formGroup]="form" autocomplete="off" novalidate>

    <div class="form-group">
      <label class="mb-2">Select type</label> <br>
      <div class="form-check form-check-inline mb-2" *ngFor="let type of types">
        <check-input name="select-type" type="radio" [value]="type.key" formControlName="productType">
          {{ type.label }}
        </check-input>
      </div>

<!--      <div class="form-check">-->
<!--        <check-input name="sandbox" formControlName="sandBox">SandBox</check-input>-->
<!--      </div>-->
    </div>

    <div class="form-group" *ngIf="form.get('entity')">
      <label>Entity</label>
      <form-group-select bindLabel="label"
                         [searchable]="true"
                         [items]="entities"
                         bindValue="key"
                         placeholder="Entity"
                         formControlName="entity">
      </form-group-select>
    </div>

    <div class="form-group" *ngIf="form.get('project') && form.get('entity').value === 'project'">
      <label>Project</label>
      <form-group-select entity="project"
                         bindLabel="name"
                         [searchable]="true"
                         [storeQuery]="{store: item?.store?.id}"
                         bindValue="id"
                         placeholder="Project"
                         formControlName="project">
      </form-group-select>
    </div>

    <div class="form-group" *ngIf="form.get('storeCollection') && form.get('entity').value === 'storeCollection'">
      <label>Collection</label>
      <form-group-select entity="storeCollection"
                         bindLabel="name"
                         [searchable]="true"
                         [storeQuery]="{store: item?.store?.id}"
                         bindValue="id"
                         placeholder="Collection"
                         formControlName="storeCollection">
      </form-group-select>
    </div>

    <div class="form-group w-50" *ngIf="form.get('coinsValue')">
      <label>Amount</label>
      <form-group-simple name="coinsValue"
                         inputType="number"
                         placeholder="Amount"
                         formControlName="coinsValue">
      </form-group-simple>
    </div>

    <div class="form-group w-50" *ngIf="form.get('period')">
      <label>Period</label>
      <form-group-date [default]="true"
                       placeholder="Expired at"
                       formControlName="period">
      </form-group-date>
    </div>

<!--    <div class="form-group">-->
<!--      <label>Store</label>-->
<!--      <form-group-select bindLabel="name"-->
<!--                         [searchable]="true"-->
<!--                         entity="store"-->
<!--                         bindValue="id"-->
<!--                         placeholder="Store"-->
<!--                         formControlName="parentStore">-->
<!--      </form-group-select>-->
<!--    </div>-->

    <div class="form-group">
      <label>Comment</label>
      <form-group-simple name="comment"
                         type="textarea"
                         placeholder="Add comment"
                         formControlName="comment" >
      </form-group-simple>
    </div>
  </form>
</div>
<div class="modal-footer border-0 pt-0">
  <button class="btn btn-secondary mr-2" (click)="addPurchase()">
    Add purchase
  </button>
  <button class="btn btn-outline-info" (click)="modalRef.hide()">
    Cancel
  </button>
</div>
